<template>
  <div class="containerTable">
    <vxe-toolbar fixed="top">
      <template v-slot:buttons>
        <el-button @click="funcFilter">查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable1"
      height="85%"
      border
      class="radio-table"
      :radio-config="{ highlight: true }"
      :data="tableData"
      @radio-change="radioChangeEvent"
    >
      <!-- 项目信息TODO: 项目名称-线路简称-接单方式-装车地址-卸车地址-货物名称-货物数量-运费单价-车数要求 -->
      <!-- <vxe-table-column type="radio" width="60" /> -->
      <vxe-table-column>
        <vxe-table-column
          field="projectName"
          title="项目名称"
          min-width="160"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.projectName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="lineName" title="线路简称" min-width="160" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.lineName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="receiveOrderMethod"
          title="接单方式"
          min-width="160"
          :formatter="receiveOrderMethodStatus"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.receiveOrderMethod"
            clearable
            placeholder="请选择接单方式"
          >
            <el-option label="发布至大厅" :value="0" />
            <el-option label="仅扫码接单" :value="1" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装车地址"
          min-width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸车地址"
          min-width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物名称"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入货物名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="weight" title="货物数量" min-width="200" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.weight"
            placeholder="请输入内容"
            type="number"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="price" title="运费单价" min-width="200" />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.priceStart"
                placeholder="下限"
                type="number"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.priceEnd"
                placeholder="上限"
                type="number"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="coalNumber" title="车数要求" min-width="200" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="90" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="handleClick(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="取消常发" placement="top">
            <vxe-button type="text" @click.native="cancelOftenOrder(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="details"
      title="货源单详情"
      width="1000"
      height="600"
      resize
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
  </div>
</template>

<script>
  import ordergoods from "@/components/TransportOrderDetails";
  import {
  cancelOftenOrder,
} from "@/api/orderform";
import { SupplyManagement } from "@/api/orderform";
export default {
  name: "Child",
  components: {
    ordergoods
  },
  data() {
    return {
      details: false,
      loading: false,
      getdata: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        isOftenOrder: 1
      },
      Pagingconf: [],
      tableData: [],
      options2: [
        {
          value: "0",
          label: "不允许"
        },
        {
          value: "1",
          label: "允许"
        }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.shipmentlist();
  },
  methods: {
    handleClick(code) {
      this.$refs.detailRef.Getdetails(code);
      this.details = true;
    },
    cancelOftenOrder(code) {
      this.$confirm("确认要取消常发设置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        cancelOftenOrder(code).then(response => {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.shipmentlist();
        });
      });
    },
    // 接单方式
    receiveOrderMethodStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "发布至大厅";
        case 1:
          return "仅扫码接单";
        default:
          break;
      }
    },
    //查询常发货源
    shipmentlist() {
      SupplyManagement(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
      });
    },
    //是否允许报价
    billingTypeStatus({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "不允许";
        case "1":
          return "允许";
        default:
          break;
      }
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.shipmentlist();
    },
    //获取选中
    getRadioEvent1() {
      this.getdata = this.$refs.xTable1.getRadioRecord();
      if (this.getdata) {
        this.$emit("event5", this.getdata);
      } else {
        this.$message({ message: "请选择一个常发货源", type: "warning" });
      }
    },
    //取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    //选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.shipmentlist();
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
